// extracted by mini-css-extract-plugin
module.exports = {"message":"SpinModal_message__1l7H0","lottie":"SpinModal_lottie__3uAiG","loseLottie":"SpinModal_loseLottie__3O4L4","notes":"SpinModal_notes__gzw07"};